module.exports = __webpack_public_path__ + "img/profile.27995e93.svg";